import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { appState } from '../AppState';
import { ADMINISTRATORS, ANALYSTS, AGENTS, KNOWLEDGEAGENT, KNOWLEDGEREADER } from '../shared/utils/constants';
import { BrowserAppTemplate } from '../browser-pages/BrowserAppTemplate';
import { SkeletonBoardHeader } from '../shared/components/Skeleton';
import { ToolbarTheme } from '@fluentui/react-teams/lib/esm/components/Toolbar/ToolbarTheme';
import { ProviderConsumer as FluentUIThemeConsumer } from '@fluentui/react-northstar';
import { SignedInConsentState, ConsentState } from '../shared/services/signInState.service';

export const SkeletonPage = ({ children }) => {
  return (
    <FluentUIThemeConsumer
      render={globalTheme => (
        <>
          <ToolbarTheme globalTheme={globalTheme}>
            <SkeletonBoardHeader />
          </ToolbarTheme>
          {children}
        </>
      )} />
  )
}

export const ChangeSkeletonVersion = ({ children }) => {
  return (
    <BrowserAppTemplate page={
      <div style={{ height: "calc(100vh - 50px)" }}>
        {children}
      </div>}
      active={'ticket'}
    />
  );
}

export const AuthorizedAdminOrAnalystsRoute = ({
  component: Component,
  ...rest
}) => {
  const { roles, isLoading } = appState().userRoles;
  const [signedIn] = SignedInConsentState.useIsSignedIn();

  return (
    <Route {...rest} render={props =>
      (signedIn !== ConsentState.SignedIn ||
        // Once the auth provider reports SignedIn, this can re-render before meAuthentication()
        // has finished populating userRoles.roles - failing open on signedIn alone isn't enough,
        // or a still-empty roles array reads as "no access" and redirects off the ticket page.
        isLoading ||
        roles.includes(ADMINISTRATORS) ||
        roles.includes(ANALYSTS) || 
        roles.includes(AGENTS) || 
        roles.includes(KNOWLEDGEAGENT) ||
        roles.includes(KNOWLEDGEREADER)) ? 
        <Component {...props} /> : 
           rest.path.includes('/tickets/:ticketId') ? 
          <Redirect to={{ pathname: `/requests/${props.match.params.ticketId}`, state: { from: props.location } }} /> : 
          <Redirect to={{ pathname: '/requests', state: { from: props.location } }} />
    } />
  );
};
